import React from "react";

export function Info() {
  return (
    <>
      <div className="bg-remark p-4 rounded border border-label overflow-hidden">
        <h4 className="lg:text-lg font-bold mb-4">【簡易購買4步曲】</h4>
        <ol className="list-decimal list-inside">
          <li className="mb-4">
            登入領籌網址, 輸入資料登記 (2020年5月25日晚上至5月30日晚上11時)
          </li>
          <li className="mb-4">
            諾翹進行抽籤及電郵通知 (2020年5月31日抽籤, 6月1日至6月3日發電郵通知)
          </li>
          <li className="mb-4">
            進入購買連結並以購買碼完成交易
            (收到指定電郵後請按電郵指示可於2020年6月1日至6月10日登入連結購買)
          </li>
          <li className="mb-4">諾翹會在6月15日到6月25日按先後次序送貨</li>
        </ol>
        <h4 className="lg:text-lg font-bold mb-4">【產品資料】</h4>
        <p className="mb-4">口罩牌子: Lockill 諾翹</p>
        <p className="mb-4">
          口罩規格: 諾翹三層即棄耳掛式外科口罩及諾翹Faceoff可重用面罩
        </p>
        <h5 className="lg:text-lg font-bold mb-4">
          LOCKILL諾翹三層即棄耳掛式外科口罩
        </h5>
        <ol className="list-inside">
          <li className="mb-4">顏色：成人為藍色, 中童為白色</li>
          <li className="mb-4">
            尺寸：
            <br />
            成人, 172mm ± 5mm x 90mm ± 3mm <br />
            中童, 138mm ± 5mm x 85mm ± 3mm
          </li>
          <li className="mb-4">標準 : ASTM F2100-2019 Level 1</li>
        </ol>
        <img className="w-full mb-4" src={require("./assets/mask.jpeg")} />
        <p className="mb-4">
          詳情可以上{" "}
          <a
            className="underline"
            target="_blank"
            href="https://www.lockill.com/202003"
          >
            www.lockill.com/202003
          </a>{" "}
          查閱
        </p>

        <h5 className="lg:text-lg font-bold mb-4">諾翹Faceoff可重用面罩</h5>
        <ol className="list-inside">
          <li className="mb-4">
            顏色：深灰色, 藍牛仔布色, 塵粉紅, 朦淺藍
            <br />
            <img className="w-full" src={require("./assets/colors.png")} />
          </li>
          <li className="mb-4">
            尺寸：Kids, Small, Medium, Large
            <img className="w-full" src={require("./assets/sizes.png")} />
          </li>
        </ol>
        <img className="w-full mb-4" src={require("./assets/faceoff.png")} />
        <p className="mb-4">
          詳情可以上{" "}
          <a
            className="underline"
            target="_blank"
            href="https://www.lockill.com/w202006"
          >
            www.lockill.com/w202006
          </a>{" "}
          查閱
        </p>

        <h4 className="lg:text-lg font-bold mb-4">【活動詳情】</h4>
        <p className="mb-4">
          每個登記都可以選擇購買成人/小童三層口罩,
          而諾翹FaceOff面罩就必須要購買其中一款3層口罩, 才可以一併購買,
          而每次登記最多可以購買5個FaceOff
        </p>

        <h4 className="lg:text-lg font-bold mb-4">【登記方式】</h4>
        <ol className="list-decimal list-inside">
          <li className="mb-4">
            於活動時間開始後，登入領籌網址，填寫電郵以作登記。
          </li>
          <li className="mb-4">
            所有填寫的資料必須正確，如有任何錯誤、遺漏或無法辨識等情況下將有機會自動作廢。
          </li>
          <li className="mb-4">登記一經確認，將不能更改任何登記資料。</li>
          <li className="mb-4">閣下所提供的資料將會用作是次登記之用。</li>
          <li className="mb-4">如有任何爭議，諾翹 Lockill將保留最終決定權。</li>
        </ol>

        <h4 className="lg:text-lg font-bold mb-4">【換領方式】</h4>
        <ol className="list-decimal list-inside">
          <li className="mb-4">
            每個成功登記，我們將會以電郵發放專屬你的購買連結。該購買連結只能使用一次，購買一個商品。而特別留意除本身三層口罩的連結之外，每購買一個FaceOff面罩會有額外另一條連結,，大家可以自由選擇顏色和大小，簡單舉例，如果你購買了2盒成人三層口罩和2個FaceOff面罩，你總共會收到3條連結，1條是購買成人三層口罩的連結，2條是購買FaceOff的連結，是次獨立收費安排是為了減低網站負荷，確保購買過程流暢
          </li>
          <li className="mb-4">
            電郵將於下午3時至5時之間發出。為了確保你的電郵系統不會把我們系統發出的電郵誤當為垃圾郵件，你可加我們系統電郵地址
            cs@boutir.com 為聯絡人，令你的電郵系統不會把 cs@boutir.com
            寄出的電郵歸類為垃圾郵件。
          </li>
          <li className="mb-4">如有任何爭議，諾翹Lockill將保留最終決定權。</li>
        </ol>

        <h3 className="lg:text-xl font-bold mb-4">條款及細則</h3>
        <p className="mb-4">
          在產品預購結束後，我們將無法接受取消或修改訂單，也無法因個人原因而提出要求產品交換/退款/退貨，如我們產品未能在2020年6月25日前送貨，你可以選擇退款或繼續等待，如選擇前者，我們將會把已收取的預訂金額全數於2020年7月2日或以前全數退回付款帳戶。成功預訂後，請保留電子收據。在領取產品時，請向我們出示相關的電子收據，並出示香港身分證以資識別；如有任何問題，請聯繫客戶服務中心
          sales@lockill.com
        </p>

        <p>
          若有任何查詢，請直接聯絡諾翹的 FB 專頁 或 電郵至
          <a className="hover:underline" href="mailto:sales@lockill.com">
            sales@lockill.com
          </a>
        </p>
      </div>
    </>
  );
}
